(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digital-bottom-2"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".section-block");

  const animateCounters = (section) => {
    const counters = section.querySelectorAll(".counter");
    counters.forEach(counter => {
      const target = +counter.getAttribute("data-percentage");
      let count = 0;
      const updateCount = () => {
        const speed = 15;
        if (count < target) {
          count++;
          counter.textContent = count + "%";
          setTimeout(updateCount, speed);
        } else {
          counter.textContent = target + "%";
        }
      };
      updateCount();
    });
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounters(entry.target);
        obs.unobserve(entry.target); // Stop observing once animated
      }
    });
  }, {
    threshold: 0.4
  });

  sections.forEach(section => {
    observer.observe(section);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digital-bottom-custom"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".section-block");

  const animateCounters = (section) => {
    const counters = section.querySelectorAll(".counter");
    counters.forEach(counter => {
      // Only animate counters with a 'data-percentage' attribute
      const target = +counter.getAttribute("data-percentage");
      if (isNaN(target)) {
        return; // Skip if there's no valid target (counter is static)
      }

      let count = 0;
      const updateCount = () => {
        const speed = 15;
        if (count < target) {
          count++;
          counter.textContent = count + "%";
          setTimeout(updateCount, speed);
        } else {
          counter.textContent = target + "%";
        }
      };
      updateCount();
    });
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounters(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.4
  });

  sections.forEach(section => {
    observer.observe(section);
  });
});

  } catch(e) { console.error(e); }
})();
})();
